"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ANONYMOUS_SUBSCRIPTION_BANNER_TITLE = exports.ANONYMOUS_SUBSCRIPTION_BANNER_READ_MORE = exports.ANONYMOUS_SUBSCRIPTION_BANNER_MESSAGE = exports.ANONYMOUS_SUBSCRIPTION_BANNER = void 0;
const ANONYMOUS_SUBSCRIPTION_BANNER = exports.ANONYMOUS_SUBSCRIPTION_BANNER = 'anonymous-subscription-banner';
const ANONYMOUS_SUBSCRIPTION_BANNER_TITLE = exports.ANONYMOUS_SUBSCRIPTION_BANNER_TITLE = 'anonymous-subscription-banner-title';
const ANONYMOUS_SUBSCRIPTION_BANNER_MESSAGE = exports.ANONYMOUS_SUBSCRIPTION_BANNER_MESSAGE = 'anonymous-subscription-banner-message';
const ANONYMOUS_SUBSCRIPTION_BANNER_READ_MORE = exports.ANONYMOUS_SUBSCRIPTION_BANNER_READ_MORE = 'anonymous-subscription-banner-read-more';
